export const cleanUndefined = <T>(obj: T) =>
  (Object.keys(obj) as Array<keyof typeof obj>).reduce(
    (acc, current) =>
      obj[current] ? { ...acc, [current]: obj[current] } : acc,
    {} as T
  );
